import { appStore } from '@kaltura-ott/tvpil-shared';

import { CONCURRENCY_DEFAULT_TTL } from '../../constants';

export const concurrencyTtl = () =>
  !appStore.concurrencyStore.concurrencyPlayerErrorTtl
    ? CONCURRENCY_DEFAULT_TTL
    : appStore.concurrencyStore.concurrencyPlayerErrorTtl;
